import { useAppSelector } from '@frontend/common';
import { SelectOption } from '@frontend/components/basic-forms';
import { UserTrigger, UserTriggerName } from '@frontend/user/types';
import { fetchGeneralWorkflowTriggers, workflowSharedStore } from '@frontend/workflow/redux';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UserTriggerSelectProps } from './user-trigger-select.component';

interface ViewProps {
    options: SelectOption<UserTriggerName>[];
}

const useUserTriggerSelect = (props: UserTriggerSelectProps): ViewProps => {
    const workflowSharedState = useAppSelector(useSelector, workflowSharedStore);

    useEffect(() => {
        props.dispatch && props.dispatch(fetchGeneralWorkflowTriggers());
    }, []);

    const options = useMemo(() => {
        if (!workflowSharedState.generalWorkflowTriggers) return [];
        const entityTriggers = Object.values(UserTriggerName);
        return [...entityTriggers, ...workflowSharedState.generalWorkflowTriggers]
            .filter((trigger) => (props.subset ? props.subset.includes(trigger) : true))
            .map((trigger) => {
                const found = UserTrigger.ALL.find((t) => t.value === trigger);
                if (found) return { value: found.value as UserTriggerName, label: found.value as UserTriggerName, display: found.displayName };
                return { value: trigger as UserTriggerName, label: trigger.replace(/_/g, ' ') as any };
            });
    }, [workflowSharedState.generalWorkflowTriggers, props.subset]);

    return { options };
};

export default useUserTriggerSelect;
